import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Parse from 'parse'
import App from '@/views/Container.vue'
import Init from '@/components/Login.vue'
import Users from '@/components/Users.vue'
import DetailU from '@/components/DetailUser.vue'
import Reservation from '@/components/Reservation.vue'
import DetailR from '@/components/DetailReservation.vue'
import Stylists from '@/components/Stylists.vue'
import DetailS from '@/components/DetailStylist.vue'
import Services from '@/components/Services.vue'
import Codes from '@/components/Codes.vue'
import Push from '@/components/Push.vue'
import Reports from '@/components/Reports.vue'
import Bloqueo from '@/components/Bloqueo.vue'


Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: Init,
  },
  {
    path: '/dashboard',
    component: App,
    children: [
      {
        path: '/',
        component: Users,
      },
      {
        path: '/users',
        component: Users,
      },
      {
        path: '/user/detail/:id',
        name: 'DetailU',
        component: DetailU,
        props: true,
      },
      {
        path: '/reservation',
        name: 'Reservation',
        component: Reservation
      },
      {
        path: '/reservation/detail/:id',
        name: 'DetailR',
        component: DetailR,
        props: true,
      },
      {
        path: '/stylist',
        name: 'Stylists',
        component: Stylists
      },
      {
        path: '/stylelist/detail/:id',
        name: 'DetailS',
        component: DetailS
      },
      {
        path: '/services',
        name: 'Services',
        component: Services
      },
      {
        path: '/bloqued',
        name: 'bloqued',
        component: Bloqueo
      },
      {
        path: '/codes',
        name: 'Codes',
        component: Codes
      },
      {
        path: '/push',
        name: 'Push',
        component: Push
      },
      {
        path: '/reports',
        name: 'Reports',
        component: Reports
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.requiresAuth) && !Parse.User.current())
    next({name: '/'})
    next()
})


export default router
